import React, { Component } from 'react'
import './App.css';
import Header from './components/header'
import Status from './components/status'
import Bluesky from './components/bluesky'

function App() {
  return (
    <div>
      <Header></Header>
      <Status></Status>
      <Bluesky></Bluesky>
    </div>

  );
}

export default App;
